import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Flotr2 - my favorite javascript graph library",
  "description": "",
  "published": "2012-06-01T00:00:00.000Z",
  "redirect_from": ["/blog/flotr2-my-favorite-javascript-graph-library/swizec/4558"],
  "categories": "Gnuplot, graph, Graph Drawing, JavaScript, Math, Mathematica, Raphael, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The more I look at it, the more it seems drawing graphs in javascript+html is the only viable option to get anything decent and useful.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.gnuplot.info/",
        "title": "Gnuplot"
      }}>{`Gnuplot`}</a>{`'s graphs work, but they're not all that pleasant to look at. Same goes for the graphing tools I've seen in python. `}<a parentName="p" {...{
        "href": "http://www.wolfram.com/products/mathematica/",
        "title": "Mathematica"
      }}>{`Mathematica`}</a>{`, I'm told, does a very decent job, but I haven't used that much.`}</p>
    <p>{`A big advantage for javascript graphing is shareability. Put up a github page, give people a link, voila. Everyone can see up to date graphs, often even interact with them.`}</p>
    <h2 {...{
      "id": "the-world-of-javascript-graphs"
    }}>{`The world of javascript graphs`}</h2>
    <p>{`Plenty graphing libraries exist for javascript ranging from extremeley simplistic to magnificently complex.`}</p>
    <p>{`The most popular are probably `}<a parentName="p" {...{
        "href": "http://d3js.org/"
      }}>{`d3.js`}</a>{` and `}<a parentName="p" {...{
        "href": "http://raphaeljs.com/"
      }}>{`Raphael`}</a>{`, both of which can get `}<em parentName="p">{`extremely`}</em>{` complicated to use, but produce arguably the shiniest and most advanced data visualisations you can imagine.`}</p>
    <p>{`Raphael is mostly a general vector library for the web. Appropriately beautiful as well.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/Screen-Shot-2012-06-01-at-2.41.59-PM.png",
        "alt": "An analytics graph in Raphael",
        "title": "An analytics graph in Raphael"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/Screen-Shot-2012-06-01-at-2.42.12-PM.png",
        "alt": "Bubble graph in Raphael",
        "title": "Bubble graph in Raphael"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/Screen-Shot-2012-06-01-at-2.42.31-PM.png",
        "alt": "A clock made with Raphael",
        "title": "A clock made with Raphael"
      }}></img></p>
    <p>{`D3.js will make your life somewhat easier in that it's at least aimed specifically at making data visualisations, but there's plenty of rope to hang yourself with.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/Screen-Shot-2012-06-01-at-3.03.35-PM.png",
        "alt": "HN top titles visualisation in d3.js",
        "title": "HN top titles visualisation in d3.js"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/Screen-Shot-2012-06-01-at-2.46.31-PM.png",
        "alt": "House hunting in d3.js",
        "title": "House hunting in d3.js"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/Screen-Shot-2012-06-01-at-2.46.53-PM.png",
        "alt": "Scatterplots made with d3.js",
        "title": "Scatterplots made with d3.js"
      }}></img></p>
    <h2 {...{
      "id": "flotr2"
    }}>{`Flotr2`}</h2>
    <p>{`Those visualisations, while incredibly shiny, are `}<em parentName="p">{`difficult`}</em>{` to make. It can take ages, trust me. I've tried and nothing I could come up with came even close. Most of all, using raphael and d3 is usually overkill - sometimes you just want a graph.`}</p>
    <p>{`To visualize `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/a-year-of-750words-com-with-shiny-graphs/swizec/4378",
        "title": "A year of 750words.com – with shiny graphs"
      }}>{`my past year of 750words`}</a>{` I used `}<a parentName="p" {...{
        "href": "http://humblesoftware.com/flotr2/"
      }}>{`Flotr2`}</a>{` - it took me ten minutes to go from parsed data dumps to shiny graphs. And that was because I had to come up with a javascript function to mangle my data into something Flotr2 will understand.`}</p>
    <p>{`The best feature is that there isn't enough rope to hang yourself with. Nor does it make you want to over-engineer a simple graph.`}</p>
    <p>{`Essentially, the code just sets up some data and a label or two:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function draw_time(container, data, title) {
  var start = new Date(DATA[0].date).getTime(),
    options,
    graph,
    i,
    x,
    o;

  options = {
    xaxis: {
      mode: "time",
      labelsAngle: 45,
    },
    selection: {
      mode: "x",
    },
    legend: {
      position: "se",
    },
    HtmlText: false,
    title: title,
  };

  // Draw graph with default options, overwriting with passed options
  function drawGraph(opts) {
    // Clone the options, so the 'options' variable always keeps intact.
    o = Flotr._.extend(Flotr._.clone(options), opts || {});

    // Return a new graph.
    return Flotr.draw(container, data, options);
  }

  graph = drawGraph();

  Flotr.EventAdapter.observe(container, "flotr:select", function (area) {
    // Draw selected area
    graph = drawGraph({
      xaxis: { min: area.x1, max: area.x2, mode: "time", labelsAngle: 45 },
      yaxis: { min: area.y1, max: area.y2 },
    });
  });

  // When graph is clicked, draw the graph with default area.
  Flotr.EventAdapter.observe(container, "flotr:click", function () {
    graph = drawGraph();
  });
}
`}</code></pre>
    <p>{`And what you get is a graph:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/Screen-Shot-2012-06-01-at-2.58.02-PM.png",
        "alt": "A graph in Flotr2",
        "title": "A graph in Flotr2"
      }}></img></p>
    <p>{`Love it.`}</p>
    <p>{`Looks good. Serves its purpose. Simple to make.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ask.metafilter.com/215379/Have-my-graph-and-graph-it-too"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_05_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://ask.metafilter.com/215379/Have-my-graph-and-graph-it-too"
        }}>{`Have my graph and graph it too?`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.r-bloggers.com/github-follower-graph-with-r/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/89526314_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.r-bloggers.com/github-follower-graph-with-r/"
        }}>{`Github Follower Graph with R`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://the.taoofmac.com/space/infoviz"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_02_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://the.taoofmac.com/space/infoviz"
        }}>{`Visualization`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.webgl.com/2012/05/webgl-demo-graph-viewer-test-vivagraph-js/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_09_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.webgl.com/2012/05/webgl-demo-graph-viewer-test-vivagraph-js/"
        }}>{`WebGL Demo - Graph Viewer Test (vivagraph.js)`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://arstechnica.com/business/2012/05/making-idiot-proof-infographics-with-infogr-am/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/91372938_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://arstechnica.com/business/2012/05/making-idiot-proof-infographics-with-infogr-am/"
        }}>{`Making idiot-proof infographics with Infogr.am`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=5580d959-40bd-49d9-87ad-b9e911728ddb",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      